import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebe76432"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "snsConfirmDialog",
  tabindex: "-1",
  "aria-labelledby": "snsConfirmDialogLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "text-center my-4 px-4"
}
const _hoisted_8 = { class: "modal-confirm-footer modal-footer d-flex justify-content-center" }
const _hoisted_9 = { class: "d-flex justify-content-lg-end justify-content-center" }
const _hoisted_10 = { class: "d-flex justify-content-lg-start justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { onMounted, ref, computed } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  emits: ['confirm'],
  setup(__props, { expose, emit }) {



const modalConfirm = ref()
const platformName = ref<string>()
const actionType = ref<'link' | 'unlink'>('unlink')

const isLink = computed(() => actionType.value === 'link')

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('snsConfirmDialog'))
})

const handleConfirm = () => {
  if (platformName.value) {
    emit('confirm', platformName.value, actionType.value)
  }
}

const modalMessage = computed(() => {
  if (!platformName.value) return ''

  if (isLink.value) {
    return translate('SD40LinkMessage')
  }

  const displayName = translate(`SD40${platformName.value}DisplayName`)
  return translate('SD40UnlinkMessage').replaceAll('%s', displayName)
})

const modalTitle = computed(() => {
  return isLink.value ? translate('SD40LinkConfirm') : translate('SD40UnlinkConfirm')
})

const submitBtnTitle = computed(() => {
  return isLink.value ? translate('SD40AddLink') : translate('SD40RemoveLink')
})

expose({
  showConfirmModal: (platform: string, type: 'link' | 'unlink' = 'unlink'): void => {
    platformName.value = platform
    actionType.value = type
    modalConfirm.value.show()
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(modalTitle)), 1),
          _hoisted_6
        ]),
        (platformName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(modalMessage)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: _unref(translate)('SE40back'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Button, {
              class: "button-submit",
              "data-bs-dismiss": "modal",
              title: _unref(submitBtnTitle),
              type: 'secondary',
              onClick: handleConfirm
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})